import { state } from "@mhmo91/schmancy/state";

// A switch the chooser asked for has landed and the plate is owed focus. The
// host that answers the switch sets it; a landed switch typically remounts the
// host, so the plate that asked never takes it: the plate marked to return
// focus that connects while it is set does. Not kept on clear, so an identity
// change forgets it.
export const focusPlateOnMount = state<boolean>(
	"workspace/focus-plate-on-mount",
).memory(false);

// <schmancy-avatar> takes `initials` but does not derive them from a name.
export const organizationInitials = (name: string) =>
	name
		.split(/\s+/)
		.reduce(
			(acc, word) =>
				acc.length < 2 && word.length > 0
					? acc + word.charAt(0).toUpperCase()
					: acc,
			"",
		) || "?";
